import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import {
  Modal,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { useLazyGetUserByIdQuery, useUpdateUsersMutation } from '../services/user';
import { showError, showToast } from '../constants/toasts';

interface EditSharedRoleModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  id?: number;
}

export default function EditSharedRoleModal({
  open,
  onClose,
  setOpen,
  id
}: EditSharedRoleModalProps) {

  const [sharedGoals, setSharedGoals] = useState(false);
  const [sharedBudgets, setSharedBudgets] = useState(false);
  const [sharedCalendar, setSharedCalendar] = useState(false);
  const [getById] = useLazyGetUserByIdQuery();
  const [updateUser] = useUpdateUsersMutation();
  const [loading, setLoading] = useState(false);

  const getDataByIdList = async () => {
    try {
      setLoading(true);
      if (!id) return;

      const response = await getById({ id: id! }).unwrap();
      if (response?.status === 200) {
        setSharedGoals(response.data.is_goal);
        setSharedBudgets(response.data.is_budget);
        setSharedCalendar(response.data.is_calender);
      }
    } catch (error: any) {
      showError(error?.message || error?.data?.message);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (id) {
      getDataByIdList();
    }
  }, [id]);


  const handleSharedGoalsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSharedGoals(event.target.checked);
  };

  const handleSharedBudgetsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSharedBudgets(event.target.checked);
  };

  const handleSharedCalendarChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSharedCalendar(event.target.checked);
  };

  const handleUpdate = async () => {
    try {
      setLoading(true);
      if (!id) return;

      const updateData = {
        id: id,
        body: {
          is_goal: sharedGoals,
          is_budget: sharedBudgets,
          is_calender: sharedCalendar
        }
      };
      const response = await updateUser(updateData).unwrap();
      if (response?.status === 200) {
        showToast('Permissions updated successfully');
        setOpen(false);
      }
    } catch (error: any) {
      showError(error?.message || error?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal className="modal editSharedRole_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Edit Shared Role & Access</h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>

          <form className="form">
            <div className="gap_p">
              <div className="control_group">
                <label>Access Permissions</label>
                <FormGroup className="list">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={sharedGoals}
                        onChange={handleSharedGoalsChange}
                      />
                    }
                    label="Shared Goals"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={sharedBudgets}
                        onChange={handleSharedBudgetsChange}
                      />
                    }
                    label="Shared Budgets"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={sharedCalendar}
                        onChange={handleSharedCalendarChange}
                      />
                    }
                    label="Shared Calendar"
                  />
                </FormGroup>
              </div>
            </div>

            {/* Footer buttons */}
            <div className="footer_btn_flex">
              <Button className="btn btn_grey" onClick={() => setOpen(false)}>
                Cancel
              </Button>
              <Button
                className="btn btn_primary"
                onClick={handleUpdate}
                disabled={loading}
              >
                {loading ? 'Updating...' : 'Update Permissions'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
